import { useQuery } from "@tanstack/react-query";

import useSalesyApiClient from "@/hooks/useSalesyApiClient";

export const getCampaignPricesKey = ["get-campaign-prices"];

export const useGetCampaignPrices = () => {
  const { apiClient } = useSalesyApiClient();

  return useQuery({
    queryKey: getCampaignPricesKey,
    queryFn: () => apiClient.predictiveCampaignPrices.getAllCampaignPrices(),
    staleTime: 1000 * 60 * 60 * 3, // 3 hours
    refetchOnWindowFocus: false,
  });
};
